import register from '../util/register'
import angular from 'angular'
import SearchController from './SearchController'

var search = angular.module(
  'app.search',
  [
    'app.searchForm',
    'app.searchResults'
  ])

register('app.search')
  .controller('SearchController', SearchController)

search.run()
